import "bootstrap/js/dist/tab";
import { html, utl_pageId } from "../base/_utils";

export default function benefitsChartInit() {
    const benefitsList = document.querySelector("#benefits-list");
    const benefitLevels = document.querySelectorAll(".list-group-item");
    const benefitsLevelTitle = document.querySelector("#benefits-level-title");

    // Set initial innerHTML of the tabContent
    let tabContent = html`
        <div id="benefits-panel" class="tab-pane fade show active p-0" role="tabpanel" aria-labelledby="${benefitLevels[0].id}" aria-live="polite">
            <ul class="list-unstyled mb-0 cols-1 cols-lg-3 px-4 pb-4">
                <!-- /* ******************** SEA OF RED ******************** */ -->
                <li class="mb-2 d-flex align-items-center p-2" data-sa-benefit-level="0">
                    <p class="benefit font-primary-bold  mb-0">Donor Decal</p>
                </li>
                <!-- /* ******************** BLACKSHIRT ******************** */ -->
                <li class="mb-2 d-flex align-items-center p-2" data-sa-benefit-level="0">
                    <p class="benefit font-primary-bold  mb-0">Annual adidas Offer</p>
                </li>
                <!-- /* ******************** CHAMPION ******************** */ -->
                <li class="mb-2 d-flex align-items-center p-2" data-sa-benefit-level="2">
                    <p class="benefit font-primary-bold  mb-0">Complimentary Lil' Huskers Membership (while supplies last)</p>
                </li>
                <!-- /* ******************** HALL OF FAME ******************** */ -->
                <li class="mb-2 d-flex align-items-center p-2" data-sa-benefit-level="3">
                    <p class="benefit font-primary-bold  mb-0">Invitation to Exclusive Nebraska Football Practice</p>
                </li>
                <li class="mb-2 d-flex align-items-center p-2" data-sa-benefit-level="3">
                    <p class="benefit font-primary-bold  mb-0">Dedicated Huskers Athletic Fund Representative</p>
                </li>

                <!-- /* ******************** BRONZE ******************** */ -->
                <li class="mb-2 d-flex align-items-center p-2" data-sa-benefit-level="4">
                    <p class="benefit font-primary-bold  mb-0">VIP Facility Tours</p>
                </li>
                <li class="mb-2 d-flex align-items-center justify-content-between p-2" data-sa-benefit-level="4">
                    <p class="benefit font-primary-bold  mb-0 pe-5 pe-sm-0">Exclusive Nebraska Leadership Society Member Apparel Opportunity</p>
                </li>
                <li class="mb-2 d-flex align-items-center justify-content-between p-2" data-sa-benefit-level="4">
                    <p class="benefit font-primary-bold  mb-0 pe-5 pe-sm-0">Exclusive Opportunities to Engage with Nebraska Athletics Leadership and Coaches</p>
                </li>

                <li class="mb-2 d-flex align-items-center justify-content-between p-2" data-sa-benefit-level="4">
                    <p class="benefit font-primary-bold  mb-0 pe-5 pe-sm-0">Nebraska Leadership Society Welcome Gift Box (one time)</p>
                </li>
                <li class="mb-2 d-flex align-items-center justify-content-between p-2" data-sa-benefit-level="4">
                    <p class="benefit font-primary-bold  mb-0 pe-5 pe-sm-0">Exclusive Huskers Events</p>
                </li>

                <li class="mb-2 d-flex align-items-center justify-content-between p-2" data-sa-benefit-level="4">
                    <p class="benefit font-primary-bold  mb-0 pe-5 pe-sm-0">Home Football Pre-Game Sideline Experience</p>
                </li>
                <!-- /* ******************** SILVER ******************** */ -->
                <li class="mb-2 d-flex align-items-center justify-content-between p-2" data-sa-benefit-level="5">
                    <p class="benefit font-primary-bold  mb-0 pe-5 pe-sm-0">Invitation to Select Team Practices</p>
                </li>
                <!-- /* ******************** GOLD ******************** */ -->
                <!-- /* ******************** GOLD ******************** */ -->
                <li class="mb-2 d-flex align-items-center justify-content-between p-2" data-sa-benefit-level="6">
                    <p class="benefit font-primary-bold  mb-0 pe-5 pe-sm-0">Opportunities for Exclusive Access at Nebraska Athletics Events</p>
                </li>
                <li class="mb-2 d-flex align-items-center justify-content-between p-2" data-sa-benefit-level="6">
                    <p class="benefit font-primary-bold  mb-0 pe-5 pe-sm-0">Eligible for Exclusive Nebraska Athletics Experiences</p>
                </li>
            </ul>
        </div>
    `;

    // NLS PAGE VARIABLE/FUNCTION
    const isNlsPage = utl_pageId() === "nls";

    // If on NLS page, remove first column and adjust col sizes to be two instead of three
    function adjustNlsColumns() {
        document.querySelector(".col1")?.remove();
        document.querySelector(".col2")?.classList.replace("col-lg-4", "col-lg-6");
        document.querySelector(".col3")?.classList.replace("col-lg-4", "col-lg-6");
    }

    // Render initial HTML of tabContent on first load
    benefitsList.innerHTML = tabContent;

    // Render initial HTML on NLS page
    if (isNlsPage) {
        benefitsList.innerHTML = tabContent;
        adjustNlsColumns();
    }

    // Select all div elements with a 'data-sa-benefit-level' attribute
    document.querySelectorAll("[data-sa-benefit-level]").forEach((item) => {
        // Parse the 'data-sa-benefit-level' attribute to an integer
        const itemLevel = parseInt(item.getAttribute("data-sa-benefit-level"));

        // NLS page check - start at Bronze level (4)
        if (isNlsPage) {
            // Check if the item level is 4 and apply a CSS class accordingly
            if (itemLevel === 4) {
                item.classList.add("added-benefit");
            } else {
                item.classList.add("unavailable-benefit");
            }
        } else {
            // Check if the item level is 0 and apply a CSS class accordingly
            if (itemLevel === 0) {
                item.classList.add("available-benefit");
            } else {
                item.classList.add("unavailable-benefit");
            }
        }
    });

    // Calculate the maximum number of benefit levels
    const maxLevels = benefitLevels.length;

    function updateBenefitStyles(current) {
        document.querySelectorAll("[data-sa-benefit-level]").forEach((item) => {
            const itemLevel = parseInt(item.getAttribute("data-sa-benefit-level"));

            // NLS page check
            if (isNlsPage) {
                // For NLS page: Apply styles for levels 4, 5, and 6
                if (itemLevel <= current) {
                    // Add .added-benefit to current and lower levels
                    item.classList.add("added-benefit");
                    item.classList.remove("unavailable-benefit", "available-benefit");
                } else {
                    // Add .unavailable-benefit to higher levels
                    item.classList.add("unavailable-benefit");
                    item.classList.remove("added-benefit", "available-benefit");
                }
            } else {
                // Default behavior for non-nls pages
                if (itemLevel === current && current !== 0) {
                    item.classList.add("added-benefit");
                    item.classList.remove("unavailable-benefit", "available-benefit");
                } else if (itemLevel >= 0 && itemLevel < current) {
                    item.classList.add("available-benefit");
                    item.classList.remove("unavailable-benefit", "added-benefit");
                } else if (current === 0 && itemLevel === 0) {
                    item.classList.add("available-benefit");
                    item.classList.remove("unavailable-benefit", "added-benefit");
                } else {
                    item.classList.add("unavailable-benefit");
                    item.classList.remove("available-benefit", "added-benefit");
                }
            }
        });
    }

    // Loop through each benefit level and add a click event listener
    for (let i = 0; i < maxLevels; i++) {
        const level = benefitLevels[i];

        level.addEventListener("click", (e) => {
            // Check if the level has an 'active' class
            if (level.classList.contains("active")) {
                // Update the benefitsLevelTitle and tabId/tabLabel variables
                benefitsLevelTitle.innerHTML = html`${level.getAttribute("data-sa-benefit-title")}<br class="d-xxl-none" />`;
            }

            // Update the benefits list content
            benefitsList.innerHTML = tabContent;

            // Adjust columns specifically for the NLS page
            isNlsPage && adjustNlsColumns();

            // const ticketsNumber = document.querySelector("#tickets-number");
            const allocationNumber = document.querySelector("#allocation-level");

            // Define ticket and allocation mappings for each index
            const ticketAllocations = [
                { tickets: "2", allocation: "5" }, // i === 0
                { tickets: "4", allocation: "4" }, // i === 1
                { tickets: "4", allocation: "3" }, // i === 2
                { tickets: "4", allocation: "2" }, // i === 3
                { tickets: "6", allocation: "1" }, // i === 4
                { tickets: "6", allocation: "1" }, // i === 5
                { tickets: "6", allocation: "1" }, // i === 6
            ];

            // Update tickets and allocation dynamically based on the current index
            if (ticketAllocations[i]) {
                // ticketsNumber ? (ticketsNumber.innerHTML = ticketAllocations[i].tickets || "") : "";
                allocationNumber ? (allocationNumber.innerHTML = ticketAllocations[i].allocation || "") : "";

                // Set bg of top 2 NLS levels to be 'included benefit' color(black) - *Annual Fund page only
                if (!isNlsPage) {
                    if (i === 5 || i === 6) {
                        allocationNumber.classList.replace("bg-primary", "bg-black");
                    } else if (i !== 5 || i !== 6) {
                        if (allocationNumber.classList.contains("bg-black")) {
                            allocationNumber.classList.replace("bg-black", "bg-primary");
                        }
                    }
                }
            }

            // Update benefits tab-pane with current attributes
            document.querySelector(".tab-pane").setAttribute("aria-labelledby", benefitLevels[i].id);

            // Map index (i) to the corresponding data-sa-benefit-level - *NLS page only
            const currentLevel = isNlsPage ? i + 4 : i;

            // Call the updateBenefitStyles function
            updateBenefitStyles(currentLevel);
        });
    }
}
